const r = (e) => e.replace(
  /[A-Z]+(?![a-z])|[A-Z]/g,
  (a, o) => (o ? "-" : "") + // if truthy, then the index is not 0 = the match is not the first letter in string
  a.toLowerCase()
);
export {
  r as convertCamelCaseToKebabCase
};
